// @flow

import { Component } from '../jsti/core';
import { stringToArray } from '../classes/Helpers';

export default class Loader extends Component {
  #notifications: {
    start: Array<string>,
    stop: Array<string>
  } = {
      start: [],
      stop: []
    };

  identifier: ?string;
  fill: boolean = false;
  parentClass: string = 'loading';
  activeClass: string = 'loader--loading';

  /**
   * Initialize the component
   *
   * @param pEl
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);

    this.identifier = this.el.dataset.loaderId;
    this.fill = this.el.classList.contains('loader--fill-content');

    this.#notifications.start = stringToArray(this.el.dataset.start);
    this.#notifications.stop = stringToArray(this.el.dataset.stop);

    for (const [key, notifications]: any of Object.entries(this.#notifications)) {
      for (const notification of notifications) {
        this.addListener(notification, this[key]);
      }
    }
  }

  /**
   * Start the loader
   */
  start(data: Object): void {
    if (data.loaderId && this.identifier !== data.loaderId) {
      return;
    }

    if (this.fill && this.el.parentElement) {
      this.el.parentElement.classList.add(this.parentClass);
    }
    this.el.classList.add(this.activeClass);
  }

  /**
   * Stop the loader
   */
  stop(data: Object): void {
    if (data.loaderId && this.identifier !== data.loaderId) {
      return;
    }

    if (this.el.parentElement) {
      this.el.parentElement.classList.remove(this.parentClass);
    }
    this.el.classList.remove(this.activeClass);
  }
}
